import React from "react";

import {buildFlatPriceVariantUrl} from "../helpers/get_flat_price_variant_links";
import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

interface IProps {
    regionSlug: string;
    regionNameDeclensionWhere: string;
    priceVariants: number[];
}

export const OfferLocationLinksPriceVariants = React.memo((props: IProps) => {
    const {regionSlug, regionNameDeclensionWhere, priceVariants} = props;

    return (
        <>
            {priceVariants.map((priceTo) => (
                <OfferLocationLinksItem
                    key={priceTo}
                    disableSelfLinking
                    linkText={`Mieszkania ${regionNameDeclensionWhere} do ${priceTo / 1000} tys zł`}
                    url={buildFlatPriceVariantUrl(regionSlug, priceTo)}
                />
            ))}
        </>
    );
});
import React from "react";

import {buildFlatPriceVariantUrl} from "../helpers/get_flat_price_variant_links";
import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

interface IProps {
    regionSlug: string;
    regionNameDeclensionWhere: string;
    priceVariants: number[];
}

export const OfferLocationLinksPriceVariants = React.memo((props: IProps) => {
    const {regionSlug, regionNameDeclensionWhere, priceVariants} = props;

    return (
        <>
            {priceVariants.map((priceTo) => (
                <OfferLocationLinksItem
                    key={priceTo}
                    disableSelfLinking
                    linkText={`Mieszkania ${regionNameDeclensionWhere} do ${priceTo / 1000} tys zł`}
                    url={buildFlatPriceVariantUrl(regionSlug, priceTo)}
                />
            ))}
        </>
    );
});
